import { useLocation } from "react-router-dom";

const FloatingButtons = () => {
  const location = useLocation();

  // Admin ke tamam pages par buttons hide
  const isAdminPage = location.pathname.startsWith("/admin");

  if (isAdminPage) {
    return null;
  }

  return (
    <>
      {/* Back To Top */}
      <div className="backtotop">
        <a
          href="#"
          id="totop"
          className="u-trans-all-2s js-scroll-event on--totop flex items-center flex-col"
          data-forch="300"
          data-visibleclass="on--totop"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="my-svg"
            width="13"
            height="10"
            viewBox="0 0 9 6"
            fill="none"
          >
            <path
              d="M3.92877 5.1729L0.580521 1.82465L1.13437 0.427443L4.34416 2.80646L6.71059 0.427443L8.10779 0.993876L4.75954 5.1729C4.64206 5.29038 4.5015 5.34912 4.33786 5.34912C4.17423 5.34912 4.03786 5.29038 3.92877 5.1729Z"
              fill="#999999"
            />
          </svg>

          TOP
        </a>
      </div>

      {/* WhatsApp */}
      <div className="whatsapp">
        <a
          href="https://api.whatsapp.com/send?phone=18322782928"
          className="float-wa"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="my-float"
            src="./assets/uploads/2023/11/whatsapp-icon-1.webp"
            alt="WhatsApp"
          />
        </a>
      </div>
    </>
  );
};

export default FloatingButtons;